export const MARKET_DATA_LOADING = "MARKET_DATA_LOADING";
export const MARKET_DATA_SUCCESS = "MARKET_DATA_SUCCESS";
export const MARKET_DATA_FAIL = "MARKET_DATA_FAIL";

export const REDDIT_DATA_LOADING = "REDDIT_DATA_LOADING";
export const REDDIT_DATA_SUCCESS = "REDDIT_DATA_SUCCESS";
export const REDDIT_DATA_FAIL = "REDDIT_DATA_FAIL";

export const REDDITPOST_DATA_LOADING = "REDDITPOST_DATA_LOADING";
export const REDDITPOST_DATA_SUCCESS = "REDDITPOST_DATA_SUCCESS";
export const REDDITPOST_DATA_FAIL = "REDDITPOST_DATA_FAIL";

export const REDDITCOMMENT_DATA_LOADING = "REDDITCOMMENT_DATA_LOADING";
export const REDDITCOMMENT_DATA_SUCCESS = "REDDITCOMMENT_DATA_SUCCESS";
export const REDDITCOMMENT_DATA_FAIL = "REDDITCOMMENT_DATA_FAIL";

export const NEWS_DATA_LOADING = "NEWS_DATA_LOADING";
export const NEWS_DATA_SUCCESS = "NEWS_DATA_SUCCESS";
export const NEWS_DATA_FAIL = "NEWS_DATA_FAIL";
